
export const EVAXSEARCH = "/api/citizen/children"
export const NEW_VACCINATIONS = "/api/vaccination"
export const NEW_OCCATIONAL_VACCINATIONS = "/api/vaccination_occasional"
export const NEW_SEASON_VACCINATIONS = "/api/vaccination_seasonal"
export const NEW_FICHE_ANTIRABIES_VACCINATIONS = "/api/vaccination_antirabique/fiche/create"
export const FIRST_UPDATE_FICHE_ANTIRABIES_VACCINATIONS = "/api/vaccination_antirabique/fiche/first_update"

export const FETCH_FICHE_ANTIRABIES_VACCINATION = "/api/vaccination_antirabique/fiche/:param/details"
export const EDIT_FICHE_ANTIRABIES_VACCINATION = "/api/vaccination_antirabique/fiche/:param/update"


export const GET_ANTIRABIES_VACCINATION_LIST = "api/vaccination_antirabique/:param/vaccination_list"
export const UPDATE_ANTIRABIES_VACCINATION_SCHEMA = "api/vaccination_antirabique/:param/vaccination_update"

export const VACCINATION_SUPPORTING_FILE = "/api/"
export const VACCINATION = "/api/vaccination/:param"
export const VACCINATION_OCCATIONAL = "/api/vaccination_occasional/:param"
export const VACCINATION_SEASON = "/api/vaccination_seasonal/:param"
export const VACCINATION_POSTPONE = "/api/vaccination/:param/report"

export const VACCINATION_ANTIRABIQUE_DETAILS = "/api/vaccination_antirabique/:param/vaccination_details"

export const VACCINATION_ANTIRABIQUE_LIST = "api/vaccination_antirabique/:param/fiches_list"
export const CHECK_CITIZEN_CURRENT_PROTOCOL = "/api/vaccination_antirabique/:param/check_citizen_has_protocol_in_progress"


export const FETCH_VACCINATIONS_LIST = "/api/vaccination/:param/vaccines_list"
export const FETCH_SEASON_VACCINATIONS_LIST = "/api/vaccination_seasonal/:param/vaccines_list"

export const FETCH_OCCATIONAL_VACCINATIONS_LIST = "/api/vaccination_occasional/:param/vaccines_list"
export const FETCH_ROUTINE_VACCINATIONS_LIST = "/api/vaccination_routine/:param/vaccines_list"

export const CREATE_GROWTH = "/api/medical_folder/:param/growth_metrics/create"
export const FETCH_GROWTH_LIST = "/api/medical_folder/:param/growth_metrics/list?birthDate=:b_d"
export const FETCH_GROWTH_ITEM = "/api/medical_folder/growth_metrics/:id"
export const EDIT_GROWTH_ITEM = "/api/medical_folder/growth_metrics/:id"
export const CREATE_HEAD_CIRCUMFERENCE = "/api/medical_folder/:param/head_circumference_metrics/create?birthDate=:b_d"
export const FETCH_HEAD_CIRCUMFERENCE_LIST = "/api/medical_folder/:param/head_circumference_metrics/list?birthDate=:b_d"
export const FETCH_HEAD_CIRCUMFERENCE = "/api/medical_folder/head_circumference_metrics/:id"
export const EDIT_HEAD_CIRCUMFERENCE = "/api/medical_folder/head_circumference_metrics/:id?birthDate=:b_d"
export const COURBE_GROWTH = "/api/medical_folder/:param/growth_metrics/list?birthDate=:b_d"
export const ALLERGY_LIST = "api/medical_folder/allergies/:param/details"


export const ADD_ALLERGIES = "api/medical_folder/:param/allergies/create"
export const EDIT_ALLERGIES = "api/medical_folder/:param/allergies/update"
export const DOWNLOAD_CALENDAR = "api/get_pdf"
export const DOWNLOAD_PIECE = "api/vaccination/download-file/:param"
export const VACCINATION_RABITS_ABSENT_KPI = "api/vaccination_antirabique/absent_List"
export const EXPORT_VACCINATION_RABITS_ABSENT_EXCEL = "api/vaccination_antirabique/absent_list/excel/"
export const CLOSURE_FICHE_ANTIRABIES_VACCINATION = "/api/vaccination_antirabique/fiche/:param/closure";
export const DELETE_FICHE_ANTIRABIES_VACCINATION = "/api/vaccination_antirabique/fiche/:param/delete";

export const NEXT_VACCINATIONS = "/api/vaccination_routine/nex_vaccination"


//INTERNATIONAL VACCINATION
export const FETCH_INTERNATIONAL_VACCINATIONS_LIST = "/api/vaccination_international/:param/list"
export const FETCH_INTERNATIONAL_VACCINATION_ALL = "/api/vaccination_international/all"
export const CREATE_INTERNATIONAL_VACCINATION = "/api/vaccination_international/create"
export const EDIT_INTERNATIONAL_VACCINATION = "/api/vaccination_international/:id"
export const FETCH_INTERNATIONAL_VACCINATION = "/api/vaccination_international/:id"
export const DELETE_INTERNATIONAL_VACCINATION = "/api/vaccination_international/:id/delete"

export const FETCH_CAMPAIGN_DETAILS = "/api/campaign/retrieve"
export const GENERATE_VACCINS_DETAILS = "/api/campaign/retrieve"
export const CREATE_VACCINATION_DMSU = "/api/vaccination_dmsu/create"
export const UPDATE_VACCINATION_DMSU = "/api/v1/dmsu/vaccination-status/update"
export const CANCEL_VACCINATION_DMSU = "/api/vaccination_dmsu/cancel"
export const ANNULER_VACCINATION_DMSU = "/api/vaccination_dmsu/:param"

export const GENERATE_CARNET_VACCINATION = "api/citizen/vaccination-carnet"
export const GENERATE_MAPI = "api/mapi/by-id-sante"
export const AUTHENTICATE_DMSU = "/api/auth/token-exchange"


